import axiosInstance from './axiosConfig';
import { CodeSearchRequest, CodeSearchResponse, CodeDetailResponse } from '../types/code.types';

export const searchApi = {
    searchCodes: async (request: CodeSearchRequest): Promise<CodeSearchResponse> => {
        const response = await axiosInstance.post('/Search/search', request);
        return response.data;
    },
    quickSearch: async (term: string, maxResults: number = 10): Promise<any> => {
        const response = await axiosInstance.get('/Search/quick', {
            params: { term, maxResults }
        });
        return response.data;
    },
    getCodeDetail: async (codeType: string, code: string): Promise<CodeDetailResponse> => {
        const response = await axiosInstance.get(`/Search/detail/${codeType}/${code}`);
        return response.data;
    },
    getSuggestions: async (term: string, maxResults: number = 7): Promise<string[]> => {
        if (!term || term.length < 2) return [];
        const response = await axiosInstance.get('/Search/suggestions', {
            params: { term, maxResults }
        });
        return response.data;
    },
    submitCodeRequest: async (data: {
        conditionOrDisease: string;
        email: string;
        additionalDetails?: string;
        codeTypeNeeded?: string;
    }): Promise<{
        success: boolean;
        message: string;
        ticketId: string;
        resolvedImmediately: boolean;
    }> => {
        const response = await axiosInstance.post('/CodeRequest/submit', data);
        return response.data;
    },
};